import {useEffect,useState} from 'react'
import {envAwarePost} from '../../util/util'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Select from 'react-select'

const GymMultiSelect = ({disabled,onChange})=>{
	const [gymLoadingStatus,setGymLoadingStatus] = useState('pending')
	const [gyms,setGyms] = useState([])
	const [selectedGyms,setSelectedGyms] = useState([])
    const [selectAll,setSelectAll] = useState(false)
    const allGymOpstions = gyms.map(
    	g=>({label:g.user_name,value:g.user_id_number})
    )

	//get all gyms
	useEffect(()=>{
		envAwarePost(
			'api/users/',
			{action:'getAllGyms'}
		).then(res=>{
			setGymLoadingStatus('idle')
			if(res.success === '1'){
				setGyms(res.data)
			}else{
				window.alert(res.message)
			}
		})
	},[])
	return (
		<div>
			{gymLoadingStatus==='pending'?
				<div className="my-3 d-flex align-items-center justify-content-center">
					Loading centers <Spinner className="ml-2" animation="border" size="sm"/>
				</div>
				:
				<div className="d-flex">
					<div className="w-100">
						<Select
							isDisabled={selectAll||disabled}
							onChange={selected=>{
								onChange(selected)
								setSelectedGyms(selected)
							}}
							value={
								selectAll
								? []
								: selectedGyms
							}
							placeholder={selectAll?'All Centers':'Select...'}
							options={allGymOpstions}
							isMulti
						/>
					</div>
					<Button 
						disabled={disabled}
						onClick={()=>{
							//must call onchange here to correctly 
							//handle passing all gyms to parent components
							onChange(allGymOpstions)
							setSelectAll(!selectAll)
						}}
						variant={selectAll?"success":"outline-success"}
					>
						All
					</Button>
				</div>
			}
		</div>
	)
}

export default GymMultiSelect